import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CliqueRetire from "../../components/cliqueretire";
import Correios from "../../components/correios";
import ModalAceite from "../../components/modalaceite";
import Header from "../../components/header";
import IconBack from "../../componentsStyled/icon/Iconback";
import { Produto } from "../../components/Types";
import { Box, Button } from "@mui/material";
import MenuLateral from "../../components/MenuLateral";
import HeaderMobile from "../../components/headerMobile";
import ChatFlutuant from "../../components/ChatFlutuant";
import MiniStepper from "../../components/miniStepper";

interface ShippingProps {
  produtos?: Produto[];
}

const Shipping: React.FC<ShippingProps> = ({}) => {
  const location = useLocation();
  const [cliqueRetireSelected, setCliqueRetireSelected] = useState(false);
  const [correiosSelected, setCorreiosSelected] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [dadosFinais, setDadosFinais] = useState(location.state || {});
  const [novosDadosSelecionados, setNovosDadosSelecionados] = useState({});

  const navigate = useNavigate();

  const handleCliqueRetireSelect = () => {
    setCliqueRetireSelected(true);
    setCorreiosSelected(false);
  };

  const handleCorreiosSelect = () => {
    setCorreiosSelected(true);
    setCliqueRetireSelected(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  useEffect(() => {
    setDadosFinais(location.state || {});
  }, [location.state]);

  const handleConfirmar = () => {
    const novosDadosSelecionados = {
      ...dadosFinais,
      Shipping: cliqueRetireSelected ? "Clique Retire" : correiosSelected ? "Correios" : "",
    };

    setNovosDadosSelecionados(novosDadosSelecionados);
    openModal();
  };

  const handleBack = () => {
    navigate("/order");
  };
  return (
    <>
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <Header />
        <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={5}>
          <MenuLateral currentPage="request" />
          <Box width={"100%"} ml={2}>
            <Button onClick={handleBack}>
              <IconBack width={20} />
              <p style={{ color: "#000" }}>FORMA DE ENVIO</p>
            </Button>
            <Box display={"flex"} width={"90%"} justifyContent={"right"}>
              <MiniStepper step={3} />
            </Box>
            <Box>
              <Box display={"flex"} justifyContent="center" gap={15} alignItems="center" marginTop={2} marginBottom={2}>
                {!dadosFinais[0].allowed_clique_retire ? <CliqueRetire onSelect={handleCliqueRetireSelect} selected={cliqueRetireSelected} /> : null}
                <Correios onSelect={handleCorreiosSelect} selected={correiosSelected} />
              </Box>
              <Button
                onClick={handleConfirmar}
                disabled={!cliqueRetireSelected && !correiosSelected}
                variant="contained"
                sx={{
                  width: "25%",
                  borderRadius: 100,
                  margin: "0 auto",
                  display: "block",
                  backgroundColor: "#8F8D8E",
                  "&:hover": {
                    backgroundColor: "#221F20",
                    color: "#fff",
                  },
                }}>
                Confirmar
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* desktop */}

      {/* Mobile */}
      <Box display={{ xs: "initial", md: "none" }}>
        <HeaderMobile currentPage="request" />
        <Box>
          <Box display={"flex"} width={"100%"} justifyContent={"center"} mb={2}>
            <MiniStepper step={3} />
          </Box>
          <Button onClick={handleBack}>
            <IconBack width={20} />
            <p style={{ color: "#000" }}>FORMA DE ENVIO</p>
          </Button>

          <Box>
            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={2} marginTop={2} marginBottom={2}>
              {!dadosFinais[0].allowed_clique_retire ? <CliqueRetire onSelect={handleCliqueRetireSelect} selected={cliqueRetireSelected} /> : null}
              <Correios onSelect={handleCorreiosSelect} selected={correiosSelected} />
            </Box>
            <Box marginY={2}>
              <Button
                onClick={handleConfirmar}
                disabled={!cliqueRetireSelected && !correiosSelected}
                variant="contained"
                sx={{
                  width: "60%",
                  borderRadius: 100,
                  margin: "0 auto",
                  display: "block",
                  backgroundColor: "#221F20",
                  "&:hover": {
                    backgroundColor: "#727272",
                    color: "#fff",
                  },
                }}>
                Confirmar
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* Mobile */}
      <ChatFlutuant />

      <ModalAceite isOpen={modalIsOpen} onRequestClose={closeModal} novosDadosSelecionados={novosDadosSelecionados} />
    </>
  );
};

export default Shipping;
